/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_table_page_x_of_y = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => string} */ (i) => {
	return `Página ${i.current} de ${i.total}`
};

const en_common_table_page_x_of_y = /** @type {(inputs: { current: NonNullable<unknown>, total: NonNullable<unknown> }) => string} */ (i) => {
	return `Page ${i.current} of ${i.total}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_table_page_x_of_y = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_table_page_x_of_y(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_table_page_x_of_y", locale)
	if (locale === "es") return es_common_table_page_x_of_y(inputs)
	return en_common_table_page_x_of_y(inputs)
};
export { common_table_page_x_of_y as "common.table.page_x_of_y" }